import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AdminQueryPriority } from '@edtech-ui/constants/admin-query-status.enum';
import { SubmitAdminQuerypayload } from '@edtech-ui/core/models/admin-panel/admin-query';
import { AdminService } from '@edtech-ui/core/services/admin-dashboard/admin.service';
import { QueryService } from '@edtech-ui/core/services/admin-panel/query.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';

@Component({
	selector: 'app-queries-support',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatButtonModule,
		MatIconModule, ReactiveFormsModule,AdminHeaderComponent
	],
	templateUrl: './queries-support.component.html',
	styleUrl: './queries-support.component.scss'
})
export class QueriesSupportComponent implements OnInit, OnDestroy {

	adminQueryPriority = AdminQueryPriority;
	createQueryForm: FormGroup;
	isLoading = false;
	subscription = new Subscription();
	queries: any[] = [];
	adminEmail = 'admin.sit.ac.in';
	tenantName='Queries Management';
	tenantSubName ='Manage and respond to user queries';

	constructor(
		private _adminService: AdminService,
		private _toastr: ToastrService,
		private queryService: QueryService,
	  ) {
		this.createQueryForm = new FormGroup({
			subject: new FormControl('', [Validators.required]),
			priority: new FormControl('', [Validators.required]),
			description: new FormControl('', [Validators.required]),
		})
	}

	ngOnInit() {
		this.loadQueries();
	}

	loadQueries() {
		this.queryService.getQueries().subscribe((data) => {
			this.queries = data;
		});
	}

	submitQuery() {
		if (this.createQueryForm.invalid) {
			this.createQueryForm.markAllAsTouched();
			this._toastr.warning('Please fill all required fields before submitting.');
			return;
		}
		this.isLoading = true;

		const payload: SubmitAdminQuerypayload = {
			...this.createQueryForm.value
		}

		this.subscription.add(
			this._adminService.postSubmitAdminQuery(payload).pipe(
				tap(response => {
					if (response.Success) {
						this._toastr.success(response.Message);
						this.createQueryForm.reset();
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong. Please try again');
					return of(null);
				})
			).subscribe()
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}